<template>
  <app-back-button
    :isCanUseTelegramBackButton="isCanUseTelegramBackButton"
    :isCanGoBack="isCanGoBack"
    @goBack="backHandler"
  />
  <component :is="layout" />
</template>

<script>
import AppBackButton from "@/components/common/AppBackButton.vue";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import useVibration from "@/composition/UseVibration";
import { init, backButton, Telegram } from "@telegram-apps/sdk";
import store from "@/store";
import { mutationTypes } from "@/store";

export default {
  name: "App",
  components: {
    AppBackButton,
    DefaultLayout,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isCanUseTelegramBackButton = ref(false);
    const isCanGoBack = ref(window.history.length > 2);
    const layout = computed(() => route?.meta?.layout || DefaultLayout);
    const { vibrate } = useVibration();

    const setPlatform = (payload) =>
      store.commit(mutationTypes.SET_PLATFORM, payload);

    watch(
      () => route.name,
      (newName) => {
        vibrate(50);

        isCanGoBack.value = newName !== "home";

        if (isCanUseTelegramBackButton.value) {
          isCanGoBack.value ? backButton.show() : backButton.hide();
        }
      },
      { immediate: true }
    );

    const backHandler = () => {
      if (isCanGoBack.value) {
        router.back();
      }
    };

    const detectPlatform = () => {
      const tgPlatform = Telegram?.WebApp?.platform || "unknown";
      setPlatform(tgPlatform);
    };

    const initApp = () => {
      detectPlatform();
      initializeBackButton();
    };

    const initializeBackButton = () => {
      try {
        init();
        if (backButton.mount.isAvailable()) {
          backButton.mount();
          if (backButton.isMounted()) {
            isCanUseTelegramBackButton.value = true;
            backButton.onClick(backHandler);
          } else {
            isCanUseTelegramBackButton.value = false;
          }
        } else {
          isCanUseTelegramBackButton.value = false;
        }
      } catch (error) {
        isCanUseTelegramBackButton.value = false;
      }
    };

    onMounted(() => {
      initApp();
    });

    onUnmounted(() => {
      if (isCanUseTelegramBackButton.value) {
        backButton.offClick(backHandler);
        backButton.unmount();
      }
    });

    return {
      layout,
      isCanUseTelegramBackButton,
      isCanGoBack,
      backHandler,
    };
  },
};
</script>

<style scoped lang="less"></style>
